import React, { useEffect, useState } from "react";
import EmptyCourseDash from "../../Components/share/EmptyCourseDash/EmptyCourseDash";
import TeamTable from "../../Components/layouts/AdminDashboard/TeamTable";
import TeamModal from "../../Components/layouts/AdminDashboard/TeamModal";
import { BtnPrimary } from "../../Components/share/buttons/Btn";
import { Modal } from "../../Components/share/modal/Modal";
import useFetch from "../../Hooks/useFetch";
import MainPagination from "../../Components/share/Pageination/MainPagination";

function Teams() {
    // Todo This should removed
    const id = 11;
    // todo -----------------
    const [teamsList, setTeamsList] = useState([]);
    const [newSurvey, setNewSurvey] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const getPriorityService = useFetch({
        method: "GET",
        url: `BootCampGroupService/${id}/groups`,
        noHeader: false,
        trigger: true,
        pagination: pagination,
        setter: setTeamsList,
    });

    useEffect(() => {
        getPriorityService.reFetch();
    }, [pagination]);

    return (
        <div>
            {teamsList.length === 0 ? (
                <EmptyCourseDash name="تیم" />
            ) : (
                <div>
                    <div className=" flex SupportTicket__header justify-between items-center leading-[3.2rem] mt-[4.5rem]">
                        <h3 className=" text-[#77498F] text-[1.6rem] font-bold leading-[3.2rem] ">
                            اطلاعات گروه‌های بوت کمپ
                        </h3>
                        <BtnPrimary
                            text="ثبت گروه جدید"
                            className=" px-12 py-8 "
                            onClick={() => setNewSurvey(true)}
                        />
                    </div>
                    <TeamTable teamsList={teamsList?.results} />
                    <MainPagination
                        pagination={pagination}
                        setPagination={setPagination}
                        data={teamsList?.results}
                        pageSize={teamsList?.page_count}
                        className="mt-[3rem]"
                    />
                </div>
            )}
            <Modal show={newSurvey}>
                <TeamModal close={setNewSurvey} />
            </Modal>
        </div>
    );
}

export default Teams;
